import { render, staticRenderFns } from "./CambioDomicilio.vue?vue&type=template&id=e4c87880&"
import script from "./CambioDomicilio.vue?vue&type=script&lang=ts&"
export * from "./CambioDomicilio.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports